module.exports = __webpack_public_path__ + "img/weixin.985ced73.png";